import { render } from "./SermonResultsCard.vue?vue&type=template&id=fe184baa"
import script from "./SermonResultsCard.vue?vue&type=script&lang=js"
export * from "./SermonResultsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__